export default {
  title: 'Disposição das encomendas',
  form: {
    show_hero_image_with_offers: {
      label: 'Mostrar imagem de destaque com ofertas',
      description:
        'Por predefinição, adicionar uma imagem de oferta oculta a imagem de destaque. Ative para mostrar ambas.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
